import React, { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import Navbar from './Navbar';

/**
 * Bottom nav only on routes that previously rendered <Navbar /> in their page component:
 * Home, Search, MyPets, Profile, ProviderDashboard, ControlCenter, DeliveryDashboard, Login.
 * Hidden everywhere else (register, shop, orders, pet details, etc.).
 */
export function shouldShowNavbar(pathname) {
  const p = (pathname || '/').replace(/\/$/, '') || '/';
  const allowed = new Set([
    '/home',
    '/search',
    '/mypets',
    '/profile',
    '/provider-dashboard',
    '/control-center',
    '/control-center/campaigns',
    '/control-center/coupons',
    '/delivery-dashboard',
    '/login',
  ]);
  return allowed.has(p);
}

const RouterLayer = ({ children }) => {
  const location = useLocation();
  const showNav = useMemo(() => shouldShowNavbar(location.pathname), [location.pathname]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location]);

  return (
    <Box sx={{ p: 2 }}>
      {children}
      {showNav ? <Navbar /> : null}
    </Box>
  );
};

export default RouterLayer;
